<template>
  <HomeBanner />
  <HomeSound />
  <HomeIssues />
  <HomeAccessories />
  <HomeFooter />
</template>
<script lang="ts">
import HomeBanner from '@components/home/HomeBanner.vue'
import HomeIssues from '@components/home/HomeIssues.vue'
import HomeAccessories from '@components/home/HomeAccessories.vue'
import HomeFooter from '@components/home/HomeFooter.vue'
import { defineComponent } from 'vue'
import HomeSound from "@components/home/HomeSound.vue";
export default defineComponent({
  components: {HomeSound, HomeBanner, HomeIssues, HomeAccessories, HomeFooter }
})
</script>
